module.exports = __webpack_public_path__ + "static/media/image-7-fr.e7715940.jpg";